// extracted by mini-css-extract-plugin
export default {"note":"Note_note__UmgKB","icon":"Note_icon__81IJW","text":"Note_text__RCe1R"};